import React from "react";

import { useMessageListStyles } from "./styles";

interface UserMessageProps {
  content: string;
}

const UserMessage: React.FC<UserMessageProps> = ({ content }) => {
  const styles = useMessageListStyles();

  return (
    <div className={styles.userMessage}>
      <div className={styles.userMessageBubble}>{content}</div>
    </div>
  );
};

export default UserMessage;
